import { useState } from "react";

const WISHLIST_KEY = "maayad_wishlist";

function read(): Set<string> {
  try {
    return new Set<string>(JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]"));
  } catch {
    return new Set<string>();
  }
}

function persist(set: Set<string>) {
  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify([...set]));
  } catch {
    /* ignore quota / private-mode errors */
  }
}

/**
 * Client-side wishlist of hotel public_ids, persisted in localStorage.
 * (When a server-side wishlist is added, only this hook changes.)
 */
export function useWishlist() {
  const [ids, setIds] = useState<Set<string>>(read);

  const toggle = (id: string) =>
    setIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      persist(next);
      return next;
    });

  const remove = (id: string) =>
    setIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      persist(next);
      return next;
    });

  return { ids, toggle, remove };
}